import { combineReducers } from "redux";
import userReducer from "../slices/user/index";
import commonReducer from "../slices/common";
import signUpFieldsReducer from "../slices/Registration/SignUpSlices";
import userCommonReducer from "./Registration/CommonSlices";

export default combineReducers({
  userData: userReducer,
  commonData: commonReducer,
  userSignUpFields: signUpFieldsReducer,
  usersCommonData: userCommonReducer,
});
